import React from 'react';
import { ExportFormat } from '@ecosystem/newron-client-lib';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { useExportModal } from '@hooks/export/export-modal/UseExportModal';
import { EnabledExportPages, ProductsTabView, ViewType } from '@hooks/export/Model';
import {
  dataExportInitiatedTrackingFunction,
  useDataExportTracking,
} from '@utils/page-analytics/model/DataExportTracking';
import { ElementType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';
import { capitalize } from 'lodash';
import { SaleType } from '@models/Products';
import { WithExportButton, WithExportModal } from '@components/design';

export interface MarketCardHeaderIconProps {
  isExportButtonDisabled: boolean;
  onChartDownload: (exportFormats: ExportFormat[]) => Promise<void>;
  selectedSalesType: SaleType;
}

const ProductsCompareModalHeaderIcon: React.FC<MarketCardHeaderIconProps> = ({
  isExportButtonDisabled,
  onChartDownload,
  selectedSalesType,
}) => {
  const pagesConfig = usePageConfig();

  const {
    openExportModal,
    onCloseExportModal,
    onExportError,
    exportModalFormats,
    exportModalMessage,
    exportModalHeaderText,
    isExportModalOpen,
  } = useExportModal({
    currentPage: EnabledExportPages.Products,
    currentTab: ProductsTabView.Leaderboard,
    currentView: ViewType.LineChart,
  });

  //Amplitude tracking
  const handleDataExportTrackingFunction = useDataExportTracking('mainFiltersProducts', 'hitlistsRetailerClient');

  const handleExportTracking = () => {
    handleDataExportTrackingFunction(
      {
        elementType: ElementType.LINE_CHART,
        elementKpi: capitalize(selectedSalesType),
        elementSort: pagesConfig.sortingOptionsProducts,
      },
      dataExportInitiatedTrackingFunction,
    );
  };
  const onExportClick = () => {
    handleExportTracking();
    openExportModal();
  };

  return (
    <div className="mr-3">
      <WithExportButton disabled={isExportButtonDisabled} onClick={onExportClick} />
      <WithExportModal
        isShown={isExportModalOpen}
        exportFormats={exportModalFormats}
        message={exportModalMessage}
        title={exportModalHeaderText}
        download={onChartDownload}
        onClose={onCloseExportModal}
        onError={onExportError}
      />
    </div>
  );
};

export default ProductsCompareModalHeaderIcon;
